import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '../views/public/Login.vue'
import ForgotPassword from "../views/public/ForgotPassword.vue"
import Home from '../views/public/Home.vue'
import Business from '../views/public/Business.vue'
import Search from '../views/public/Search.vue'
import About from '../views/public/About.vue'
import Contact from '../views/public/Contact.vue'
import Terms from '../views/public/Terms.vue'
import Policy from '../views/public/Policy.vue'
import Team from '../views/public/Team.vue'
import Promotions from '../views/public/Promotions.vue'
import PromotionsGroup from '../views/public/PromotionsGroup.vue'
import Promotion from '../views/public/Promotion.vue'
import Signup from '../views/public/Signup.vue'
import Activate from '../views/public/Activate.vue'
import Categories from '../views/public/Categories.vue'
import Category from '../views/public/Category.vue'
import SubCategory from '../views/public/SubCategory.vue'
import Directory from '../views/public/Directory.vue'

import Admin from '../views/admin/Admin.vue'
import AdminDashboard from '../views/admin/AdminDashboard.vue'



import AdminPromotions from "../views/admin/promotions/AdminPromotions.vue"
import AdminPromotionsList from "../views/admin/promotions/AdminPromotionsList.vue"
import AdminPromotionsOverdue from "../views/admin/promotions/AdminPromotionsOverdue.vue"
import AdminPromotionsView from "../views/admin/promotions/AdminPromotionsView.vue"
import AdminPromotionsDelete from "../views/admin/promotions/AdminPromotionsDelete.vue"
import AdminPromotionsFeatured from "../views/admin/promotions/AdminPromotionsFeatured.vue"
import AdminPromotionsFeaturedAdd from "../views/admin/promotions/AdminPromotionsFeaturedAdd.vue"
import AdminPromotionsFeaturedEdit from "../views/admin/promotions/AdminPromotionsFeaturedEdit.vue"
import AdminPromotionsFeaturedDelete from "../views/admin/promotions/AdminPromotionsFeaturedDelete.vue"


import AdminSliders from "../views/admin/sliders/AdminSliders.vue"
import AdminSlidersList from "../views/admin/sliders/AdminSlidersList.vue"
import AdminSlidersAdd from "../views/admin/sliders/AdminSlidersAdd.vue"
import AdminSlidersEdit from "../views/admin/sliders/AdminSlidersEdit.vue"
import AdminSlidersDelete from "../views/admin/sliders/AdminSlidersDelete.vue"





import AdminBusinesses from '../views/admin/businesses/AdminBusinesses.vue'
import AdminBusinessesList from "../views/admin/businesses/AdminBusinessesList.vue"
import AdminBusinessesView from "../views/admin/businesses/AdminBusinessesView.vue"
import AdminBusinessesVerify from "../views/admin/businesses/AdminBusinessesVerify.vue"
import AdminBusinessesNoVerifyDocs from "../views/admin/businesses/AdminBusinessesNoVerifyDocs.vue"
import AdminBusinessesPendingVerify from "../views/admin/businesses/AdminBusinessesPendingVerify.vue"
import AdminBusinessesDailyRegistrations from "../views/admin/businesses/AdminBusinessesDailyRegistrations.vue"
import AdminBusinessesDelete from "../views/admin/businesses/AdminBusinessesDelete.vue"


import AdminMissing from '../views/admin/missing/AdminMissing.vue'
import AdminMissingInfo from '../views/admin/missing/AdminMissingInfo.vue'
import AdminMissingInfoGroupBusinesses from '../views/admin/missing/AdminMissingInfoGroupBusinesses.vue'
import AdminMissingInfoGroupItems from '../views/admin/missing/AdminMissingInfoGroupItems.vue'


import AdminCategories from '../views/admin/categories/AdminCategories'
import AdminCategoriesList from '../views/admin/categories/AdminCategoriesList'
import AdminSubCategoriesList from '../views/admin/categories/AdminSubCategoriesList'
import AdminCategoriesAdd from '../views/admin/categories/AdminCategoriesAdd'
import AdminCategoriesView from '../views/admin/categories/AdminCategoriesView'
import AdminCategoriesAddSubCategory from '../views/admin/categories/AdminCategoriesAddSubCategory'
import AdminCategoriesEdit from '../views/admin/categories/AdminCategoriesEdit'
import AdminCategoriesDelete from "../views/admin/categories/AdminCategoriesDelete"
import AdminSubCategoriesView from "../views/admin/categories/AdminSubCategoriesView"
import AdminSubCategoriesEdit from "../views/admin/categories/AdminSubCategoriesEdit"
import AdminSubCategoriesDelete from "../views/admin/categories/AdminSubCategoriesDelete"
import AdminSubCategoriesAdd from "../views/admin/categories/AdminSubCategoriesAdd"

import AdminLocations from '../views/admin/locations/AdminLocations'
import AdminDistrictsList from '../views/admin/locations/AdminDistrictsList'
import AdminDistrictsAdd from '../views/admin/locations/AdminDistrictsAdd'
import AdminDistrictsView from '../views/admin/locations/AdminDistrictsView'
import AdminDistrictsEdit from '../views/admin/locations/AdminDistrictsEdit'
import AdminDistrictsDelete from '../views/admin/locations/AdminDistrictsDelete'
import AdminCitiesList from '../views/admin/locations/AdminCitiesList'
import AdminCitiesAdd from '../views/admin/locations/AdminCitiesAdd'
import AdminCitiesView from '../views/admin/locations/AdminCitiesView'
import AdminCitiesEdit from '../views/admin/locations/AdminCitiesEdit'
import AdminCitiesDelete from '../views/admin/locations/AdminCitiesDelete'
import AdminWardsAdd from '../views/admin/locations/AdminWardsAdd'
import AdminWardsList from '../views/admin/locations/AdminWardsList'
import AdminWardsView from '../views/admin/locations/AdminWardsView'
import AdminWardsEdit from '../views/admin/locations/AdminWardsEdit'
import AdminWardsDelete from '../views/admin/locations/AdminWardsDelete'
import AdminStreetsAdd from '../views/admin/locations/AdminStreetsAdd'
import AdminStreetsList from '../views/admin/locations/AdminStreetsList'
import AdminStreetsView from "../views/admin/locations/AdminStreetsView"
import AdminStreetsEdit from "../views/admin/locations/AdminStreetsEdit"
import AdminStreetsDelete from "../views/admin/locations/AdminStreetsDelete"

import AdminHollidays from "../views/admin/hollidays/AdminHollidays"
import AdminHollidaysAdd from "../views/admin/hollidays/AdminHollidaysAdd"
import AdminHollidaysList from "../views/admin/hollidays/AdminHollidaysList"
import AdminHollidaysView from "../views/admin/hollidays/AdminHollidaysView"
import AdminHollidaysEdit from "../views/admin/hollidays/AdminHollidaysEdit"
import AdminHollidaysDelete from "../views/admin/hollidays/AdminHollidaysDelete"


import AdminNewsLetters from "../views/admin/news_letters/AdminNewsLetters"
import AdminNewsLettersList from "../views/admin/news_letters/AdminNewsLettersList"
import AdminNewsLettersView from "../views/admin/news_letters/AdminNewsLettersView"

import AdminContactUsMessages from "../views/admin/contact_us_messages/AdminContactUsMessages"
import AdminContactUsMessagesList from "../views/admin/contact_us_messages/AdminContactUsMessagesList"
import AdminContactUsMessagesView from "../views/admin/contact_us_messages/AdminContactUsMessagesView"


import AdminReports from "../views/admin/reports/AdminReports"
import AdminReportsRegistrations from "../views/admin/reports/AdminReportsRegistrations"
import AdminReportsPromotions from "../views/admin/reports/AdminReportsPromotions"
import AdminReportsOverdue from "../views/admin/reports/AdminReportsOverdue"
import AdminReportsPromoViews from "../views/admin/reports/AdminReportsPromoViews"
import AdminReportsBusinessViews from "../views/admin/reports/AdminReportsBusinessViews"
import AdminReportsBusinessSearches from "../views/admin/reports/AdminReportsBusinessSearches"
import AdminReportsAdvertClicks from "../views/admin/reports/AdminReportsAdvertClicks"

import AdminAdverts from '../views/admin/adverts/AdminAdverts.vue'
import AdminAdvertsAdd from '../views/admin/adverts/AdminAdvertsAdd.vue'
import AdminAdvertsEdit from '../views/admin/adverts/AdminAdvertsEdit.vue'
import AdminAdvertsList from '../views/admin/adverts/AdminAdvertsList.vue'
import AdminAdvertsView from '../views/admin/adverts/AdminAdvertsView.vue'
import AdminAdvertsDelete from '../views/admin/adverts/AdminAdvertsDelete.vue'

import AdminUsers from '../views/admin/users/AdminUsers.vue'
import AdminUsersList from '../views/admin/users/AdminUsersList.vue'
import AdminUsersDisable from '../views/admin/users/AdminUsersDisable.vue'
import AdminUsersActivate from '../views/admin/users/AdminUsersActivate.vue'
import AdminUsersDelete from '../views/admin/users/AdminUsersDelete.vue'
import AdminAddSystemAdmins from '../views/admin/users/AdminAddSystemAdmins.vue'
import AdminSystemAdminsList from '../views/admin/users/AdminSystemAdminsList.vue'
import AdminSystemAdminsDelete from '../views/admin/users/AdminSystemAdminsDelete.vue'






import Owner from '../views/business_owner/Owner.vue'
import OwnerDashboard from '../views/business_owner/OwnerDashboard.vue'



import OwnerPromotions from "../views/business_owner/promotions/OwnerPromotions.vue"
import OwnerPrommotionsList from "../views/business_owner/promotions/OwnerPrommotionsList.vue"
import OwnerPromtionsView from "../views/business_owner/promotions/OwnerPromtionsView.vue"
import OwnerPromtionsDelete from "../views/business_owner/promotions/OwnerPromtionsDelete.vue"
import OwnerPrommotionsAdd from "../views/business_owner/promotions/OwnerPrommotionsAdd.vue"
import OwnerPromtionsEnd from "../views/business_owner/promotions/OwnerPromtionsEnd.vue"
import OwnerPromotionsEdit from "../views/business_owner/promotions/OwnerPromotionsEdit.vue"

import OwnerBusinesses from "../views/business_owner/businesses/OwnerBusinesses.vue"
import OwnerBusinessesRegister from "../views/business_owner/businesses/OwnerBusinessesRegister.vue"
import OwnerBusinessesList from "../views/business_owner/businesses/OwnerBusinessesList.vue"
import OwnerBusinessesView from "../views/business_owner/businesses/OwnerBusinessesView.vue"
import OwnerBusinessesManageProducts from "../views/business_owner/businesses/OwnerBusinessesManageProducts.vue"
import OwnerBusinessesManageServices from "../views/business_owner/businesses/OwnerBusinessesManageServices.vue"
import OwnerBusinessesManageLocations from "../views/business_owner/businesses/OwnerBusinessesManageLocations.vue"
import OwnerBusinessesDelete from "../views/business_owner/businesses/OwnerBusinessesDelete.vue"
import OwnerBusinessesManageSchedule from "../views/business_owner/businesses/OwnerBusinessesManageSchedule.vue"
import OwnerBusinessesManageHolidaysSchedule from "../views/business_owner/businesses/OwnerBusinessesManageHolidaysSchedule.vue"
import OwnerBusinessesEditInfo from "../views/business_owner/businesses/OwnerBusinessesEditInfo.vue"
import OwnerBusinessesVerify from "../views/business_owner/businesses/OwnerBusinessesVerify.vue"
import OwnerBusinessesEditBanner from "../views/business_owner/businesses/OwnerBusinessesEditBanner.vue"
import OwnerBusinessesManageContacts from "../views/business_owner/businesses/OwnerBusinessesManageContacts.vue"
import OwnerBusinessesManageGallery from "../views/business_owner/businesses/OwnerBusinessesManageGallery.vue"

import OwnerMissingInfo from "../views/business_owner/missing/OwnerMissingInfo.vue"
import OwnerMissing from "../views/business_owner/missing/OwnerMissing.vue"
import OwnerMissingInfoGroupBusinesses from "../views/business_owner/missing/OwnerMissingInfoGroupBusinesses.vue"
import OwnerMissingInfoGroupItems from "../views/business_owner/missing/OwnerMissingInfoGroupItems.vue"

import OwnerContactUsMessages from "../views/business_owner/contact_us_messages/OwnerContactUsMessages"
import OwnerContactUsMessagesList from "../views/business_owner/contact_us_messages/OwnerContactUsMessagesList"
import OwnerContactUsMessagesView from "../views/business_owner/contact_us_messages/OwnerContactUsMessagesView"

import OwnerNotifications from "../views/business_owner/notifications/OwnerNotifications.vue"
import OwnerNotificationsList from "../views/business_owner/notifications/OwnerNotificationsList.vue"

import OwnerReports from "../views/business_owner/reports/OwnerReports.vue"
import OwnerReportsPromotions from "../views/business_owner/reports/OwnerReportsPromotions.vue"
import OwnerReportsOverdue from "../views/business_owner/reports/OwnerReportsOverdue.vue"
import OwnerReportsBusinessViews from "../views/business_owner/reports/OwnerReportsBusinessViews.vue"
import OwnerReportsBusinessSearches from "../views/business_owner/reports/OwnerReportsBusinessSearches.vue"
import OwnerReportsBusinessReviews from "../views/business_owner/reports/OwnerReportsBusinessReviews.vue"
import OwnerReportsBusinessRatings from "../views/business_owner/reports/OwnerReportsBusinessRatings.vue"

import OwnerSecurity from "../views/business_owner/security/OwnerSecurity.vue"
import OwnerSecurityPassword from "../views/business_owner/security/OwnerSecurityPassword.vue"
import OwnerSecurityUsername from "../views/business_owner/security/OwnerSecurityUsername.vue"
import OwnerSecurityDetails from "../views/business_owner/security/OwnerSecurityDetails.vue"




Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      auth: false,
      title: 'Home'
    }
  },
  {
    path: '/home',
    name: 'Home Path',
    component: Home,
    meta: {
      auth: false,
      title: 'Home'
    }
  },
  {
    path: '/businesses/:id',
    name: 'Business View',
    component: Business,
    meta: {
      auth: false,
      title: 'Business'
    }
  },
  {
    path: '/search',
    name: 'Search',
    component: Search,
    meta: {
      auth: false,
      title: 'Search'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      auth: false,
      title: 'Login'
    }
  },
  {
    path: '/forgot',
    name: 'Forgot',
    component: ForgotPassword,
    meta: {
      auth: false,
      title: 'Forgot Password'
    }
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup,
    meta: {
      auth: false,
      title: 'Signup'
    }
  },
  {
    path: '/activate',
    name: 'Activate',
    component: Activate,
    meta: {
      auth: false,
      title: 'Activate Account'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //component: () => import(/* webpackChunkName: "about" */ '../views/public/About.vue')
    meta: {
      auth: false,
      title: 'About Us -BWS'
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
    meta: {
      auth: false,
      title: 'Contact Us -BWS'
    }
  },
  {
    path: '/terms',
    name: 'Terms',
    component: Terms,
    meta: {
      auth: false,
      title: 'Terms Of Use -BWS'
    }
  },
  {
    path: '/policy',
    name: 'Policy',
    component: Policy,
    meta: {
      auth: false,
      title: 'Privacy Policy -BWS'
    }
  },
  {
    path: '/team',
    name: 'Team',
    component: Team,
    meta: {
      auth: false,
      title: 'Team work -BWS'
    }
  },
  {
    path: '/admin',
    component: Admin,
    children: [
      {
        // UserProfile will be rendered inside User's <router-view>
        // when /user/:id/profile is matched
        path: '/admin/dashboard',
        component: AdminDashboard,
        meta: {
          auth: true,
          title: 'Dashboard'
        }
      },
      {

        path: '/admin/categories',
        component: AdminCategories,
        meta: {
          auth: true,
          title: 'AdminCategories'
        },
        children: [
          {

            path: '/admin/categories/list',
            component: AdminCategoriesList,
            meta: {
              auth: true,
              title: 'Admin Categories List'
            }
          },
          {

            path: '/admin/categories/add',
            component: AdminCategoriesAdd,
            meta: {
              auth: true,
              title: 'Admin Categories New'
            }
          },
          {

            path: '/admin/categories/view/:id',
            component: AdminCategoriesView,
            meta: {
              auth: true,
              title: 'Admin View Category'
            }
          },
          {

            path: '/admin/categories/view/:id/add/subcategory',
            component: AdminCategoriesAddSubCategory,
            meta: {
              auth: true,
              title: 'Admin Add Sub Category'
            }
          },
          {

            path: '/admin/categories/view/:id/edit',
            component: AdminCategoriesEdit,
            meta: {
              auth: true,
              title: 'Admin Edit Category'
            }
          },
          {

            path: '/admin/categories/view/:id/delete',
            component: AdminCategoriesDelete,
            meta: {
              auth: true,
              title: 'Admin Delete Category'
            }
          },
          {
            path: '/admin/categories/sub_categories/list',
            component: AdminSubCategoriesList,
            meta: {
              auth: true,
              title: 'Admin Sub Categories List'
            }
          },
          {
            path: '/admin/categories/sub_categories/view/:id',
            component: AdminSubCategoriesView,
            meta: {
              auth: true,
              title: 'Admin Sub Categories View'
            }
          },
          {
            path: '/admin/categories/sub_categories/view/:id/edit',
            component: AdminSubCategoriesEdit,
            meta: {
              auth: true,
              title: 'Admin Sub Categories Edit'
            }
          },
          {
            path: '/admin/categories/sub_categories/view/:id/delete',
            component: AdminSubCategoriesDelete,
            meta: {
              auth: true,
              title: 'Admin Sub Categories Delete'
            }
          },
          {
            path: '/admin/categories/sub_categories/add',
            component: AdminSubCategoriesAdd,
            meta: {
              auth: true,
              title: 'Admin Add New Sub Categories'
            }
          },

        ]
      },
      {
        path: '/admin/locations',
        component: AdminLocations,
        meta: {
          auth: true,
          title: 'AdminLocations'
        },
        children: [
          {
            path: '/admin/locations/districts/list',
            component: AdminDistrictsList,
            meta: {
              auth: true,
              title: 'Admin Districts List'
            }
          },
          {

            path: '/admin/locations/districts/add',
            component: AdminDistrictsAdd,
            meta: {
              auth: true,
              title: 'Admin Districts Add'
            }
          },

          {
            path: '/admin/locations/districts/view/:id',
            component: AdminDistrictsView,
            meta: {
              auth: true,
              title: 'Admin Districts View'
            }
          },
          {

            path: '/admin/locations/districts/view/:id/edit',
            component: AdminDistrictsEdit,
            meta: {
              auth: true,
              title: 'Admin Districts Edit '
            }
          },
          {
            path: '/admin/locations/districts/view/:id/delete',
            component: AdminDistrictsDelete,
            meta: {
              auth: true,
              title: 'Admin Districts Delete'
            }
          },
          {

            path: '/admin/locations/cities/list',
            component: AdminCitiesList,
            meta: {
              auth: true,
              title: 'Admin Cities List'
            }
          },
          {

            path: '/admin/locations/cities/add',
            component: AdminCitiesAdd,
            meta: {
              auth: true,
              title: 'Admin Cities Add'
            }
          },
          {

            path: '/admin/locations/cities/view/:id',
            component: AdminCitiesView,
            meta: {
              auth: true,
              title: 'Admin View Cities'
            }
          },
          {

            path: '/admin/locations/cities/view/:id/edit',
            component: AdminCitiesEdit,
            meta: {
              auth: true,
              title: 'Admin Edit City'
            }
          },
          {
            path: '/admin/locations/cities/view/:id/delete',
            component: AdminCitiesDelete,
            meta: {
              auth: true,
              title: 'Admin City Delete'
            }
          },
          {
            path: '/admin/locations/wards/add',
            component: AdminWardsAdd,
            meta: {
              auth: true,
              title: 'Admin Wards Add'
            }
          },
          {
            path: '/admin/locations/wards/list',
            component: AdminWardsList,
            meta: {
              auth: true,
              title: 'Admin Wards List'
            }
          },
          {
            path: '/admin/locations/wards/view/:id',
            component: AdminWardsView,
            meta: {
              auth: true,
              title: 'Admin Wards View'
            }
          },
          {
            path: '/admin/locations/wards/view/:id/edit',
            component: AdminWardsEdit,
            meta: {
              auth: true,
              title: 'Admin Wards Edit'
            }
          },
          {
            path: '/admin/locations/wards/view/:id/delete',
            component: AdminWardsDelete,
            meta: {
              auth: true,
              title: 'Admin Wards Delete'
            }
          },
          {
            path: '/admin/locations/streets/add',
            component: AdminStreetsAdd,
            meta: {
              auth: true,
              title: 'Admin Streets Add'
            }
          },
          {
            path: '/admin/locations/streets/list',
            component: AdminStreetsList,
            meta: {
              auth: true,
              title: 'Admin Streets List'
            }
          },
          {
            path: '/admin/locations/streets/view/:id',
            component: AdminStreetsView,
            meta: {
              auth: true,
              title: 'Admin Streets View'
            }
          },
          {
            path: '/admin/locations/streets/view/:id/edit',
            component: AdminStreetsEdit,
            meta: {
              auth: true,
              title: 'Admin Streets Edit'
            }
          },
          {
            path: '/admin/locations/streets/view/:id/delete',
            component: AdminStreetsDelete,
            meta: {
              auth: true,
              title: 'Admin Streets Delete'
            }
          },
        ]
      },
      {
        path: '/admin/hollidays',
        component: AdminHollidays,
        meta: {
          auth: true,
          title: 'AdminHollidays'
        },
        children: [
          {
            path: '/admin/hollidays/add',
            component: AdminHollidaysAdd,
            meta: {
              auth: true,
              title: 'Admin Hollidays Add'
            }
          },
          {
            path: '/admin/hollidays/list',
            component: AdminHollidaysList,
            meta: {
              auth: true,
              title: 'Admin Hollidays List'
            }
          },
          {
            path: '/admin/hollidays/list/view/:id',
            component: AdminHollidaysView,
            meta: {
              auth: true,
              title: 'Admin Hollidays View'
            }
          },
          {
            path: '/admin/hollidays/list/view/:id/edit',
            component: AdminHollidaysEdit,
            meta: {
              auth: true,
              title: 'Admin Hollidays Edit'
            }
          },
          {
            path: '/admin/hollidays/list/view/:id/delete',
            component: AdminHollidaysDelete,
            meta: {
              auth: true,
              title: 'Admin Hollidays Delete'
            }
          }
        ]
      },
      {
        path: '/admin/new_letters',
        component: AdminNewsLetters,
        meta: {
          auth: true,
          title: 'News Letters'
        },
        children: [
          {
            path: '/admin/new_letters/list',
            component: AdminNewsLettersList,
            meta: {
              auth: true,
              title: 'Admin Letters List'
            }
          },
          {
            path: '/admin/new_letters/list/view/:id',
            component: AdminNewsLettersView,
            meta: {
              auth: true,
              title: 'Admin Letters View'
            }
          },


        ]
      },
      {
        path: '/admin/contact_us_messages',
        component: AdminContactUsMessages,
        meta: {
          auth: true,
          title: 'Contact Us Messages'
        },
        children: [
          {
            path: '/admin/contact_us_messages/list',
            component: AdminContactUsMessagesList,
            meta: {
              auth: true,
              title: 'Admin Contact Us Messages'
            }
          },
          {
            path: '/admin/contact_us_messages/list/view/:id',
            component: AdminContactUsMessagesView,
            meta: {
              auth: true,
              title: 'Admin View Contact Us Messages'
            }
          },
        ]
      },
      {
        path: '/admin/missing',
        component: AdminMissing,
        meta: {
          auth: true,
          title: 'Businesses Missing Information Management'
        },
        children: [
          {
            path: '/admin/missing/info',
            component: AdminMissingInfo,
            meta: {
              auth: true,
              title: 'Businesses Missing Information List'
            }
          },
          {
            path: '/admin/missing/groupby/businesses',
            component: AdminMissingInfoGroupBusinesses,
            meta: {
              auth: true,
              title: 'Businesses Missing Information Groups'
            }
          },
          {
            path: '/admin/missing/groupby/item',
            component: AdminMissingInfoGroupItems,
            meta: {
              auth: true,
              title: 'Businesses Missing Information Item Groups'
            }
          },
        ]
      },
      {
        path: '/admin/businesses',
        component: AdminBusinesses,
        meta: {
          auth: true,
          title: 'Registered Businesses'
        },
        children: [
          {
            path: '/admin/businesses/list',
            component: AdminBusinessesList,
            meta: {
              auth: true,
              title: 'Register Businesses List'
            }
          },
          {
            path: '/admin/businesses/list/view/:id',
            component: AdminBusinessesView,
            meta: {
              auth: true,
              title: 'Registered Business Details View'
            }
          },
          {
            path: '/admin/businesses/list/view/:id/verify',
            component: AdminBusinessesVerify,
            meta: {
              auth: true,
              title: 'Verify Business'
            }
          },
          {
            path: '/admin/businesses/reports/verify/nodocs',
            component: AdminBusinessesNoVerifyDocs,
            meta: {
              auth: true,
              title: 'Business Missing Verification Docs'
            }
          },
          {
            path: '/admin/businesses/reports/verify/pending',
            component: AdminBusinessesPendingVerify,
            meta: {
              auth: true,
              title: 'Business With Pending Verification'
            }
          },
          {
            path: '/admin/businesses/reports/registrations/daily',
            component: AdminBusinessesDailyRegistrations,
            meta: {
              auth: true,
              title: 'Daily Registrations'
            }
          },
          {
            path: '/admin/businesses/list/view/:id/delete',
            component: AdminBusinessesDelete,
            meta: {
              auth: true,
              title: 'Delete Business'
            }
          },

        ]
      },
      {
        path: '/admin/promotions',
        component: AdminPromotions,
        meta: {
          auth: true,
          title: 'Promotions Management'
        },
        children: [
          {
            path: '/admin/promotions/list',
            component: AdminPromotionsList,
            meta: {
              auth: true,
              title: 'Promotions List'
            }
          },
          {
            path: '/admin/promotions/overdue',
            component: AdminPromotionsOverdue,
            meta: {
              auth: true,
              title: 'Promotions Overdue'
            }
          },
          {
            path: '/admin/promotions/list/view/:id',
            component: AdminPromotionsView,
            meta: {
              auth: true,
              title: 'View Promotion Details'
            }
          },
          {
            path: '/admin/promotions/list/view/:id/delete',
            component: AdminPromotionsDelete,
            meta: {
              auth: true,
              title: 'Delete Promotion'
            }
          },
          {
            path: '/admin/promotions/featured',
            component: AdminPromotionsFeatured,
            meta: {
              auth: true,
              title: 'Featured Promotions'
            }
          },
          {
            path: '/admin/promotions/add/featured',
            component: AdminPromotionsFeaturedAdd,
            meta: {
              auth: true,
              title: 'Feature A Promotion'
            }
          },
          {
            path: '/admin/promotions/edit/featured/:id',
            component: AdminPromotionsFeaturedEdit,
            meta: {
              auth: true,
              title: 'Edit Featured Promotion'
            }
          },
          {
            path: '/admin/promotions/delete/featured/:id',
            component: AdminPromotionsFeaturedDelete,
            meta: {
              auth: true,
              title: 'Delete Featured Promotion'
            }
          }
        ]
      },
      {
        path: '/admin/adverts',
        component: AdminAdverts,
        meta: {
          auth: true,
          title: 'Advertisments'
        },
        children: [
          {
            path: '/admin/adverts/list',
            component: AdminAdvertsList,
            meta: {
              auth: true,
              title: 'Adverts List'
            }
          },
          {
            path: '/admin/adverts/add',
            component: AdminAdvertsAdd,
            meta: {
              auth: true,
              title: 'Add New Advert'
            }
          },
          {
            path: '/admin/adverts/list/view/:id/edit',
            component: AdminAdvertsEdit,
            meta: {
              auth: true,
              title: 'Edit Advert'
            }
          },
          {
            path: '/admin/adverts/list/view/:id',
            component: AdminAdvertsView,
            meta: {
              auth: true,
              title: 'View Advert'
            }
          },
          {
            path: '/admin/adverts/list/view/:id/delete',
            component: AdminAdvertsDelete,
            meta: {
              auth: true,
              title: 'Delete Advert'
            }
          },
        ]
      },
      {
        path: '/admin/reports',
        component: AdminReports,
        meta: {
          auth: true,
          title: 'Reports'
        },
        children: [
          {
            path: '/admin/reports/registrations',
            component: AdminReportsRegistrations,
            meta: {
              auth: true,
              title: 'Registrations Report'
            }
          },
          {
            path: '/admin/reports/promotions',
            component: AdminReportsPromotions,
            meta: {
              auth: true,
              title: 'Promotions Report'
            }
          },
          {
            path: '/admin/reports/overdue',
            component: AdminReportsOverdue,
            meta: {
              auth: true,
              title: 'Overdue Promotions Report'
            }
          },
          {
            path: '/admin/reports/promoviews',
            component: AdminReportsPromoViews,
            meta: {
              auth: true,
              title: 'Promotion Views Report'
            }
          },
          {
            path: '/admin/reports/views/activity',
            component: AdminReportsBusinessViews,
            meta: {
              auth: true,
              title: 'Business Views Report'
            }
          },
          {
            path: '/admin/reports/searches/activity',
            component: AdminReportsBusinessSearches,
            meta: {
              auth: true,
              title: 'Business Searches Report'
            }
          },
          {
            path: '/admin/reports/adverts',
            component: AdminReportsAdvertClicks,
            meta: {
              auth: true,
              title: 'Advert Clicks Report'
            }
          },
        ]
      },
      {
        path: '/admin/users',
        component: AdminUsers,
        meta: {
          auth: true,
          title: 'Users'
        },
        children: [{
          path: '/admin/users/list',
          component: AdminUsersList,
          meta: {
            auth: true,
            title: 'Users List'
          }
        },{
          path: '/admin/users/list/disable/:id',
          component: AdminUsersDisable,
          meta: {
            auth: true,
            title: 'Disable Users Account'
          }
        },{
          path: '/admin/users/list/activate/:id',
          component: AdminUsersActivate,
          meta: {
            auth: true,
            title: 'Enable Users Account'
          }
        },{
          path: '/admin/users/list/delete/:id',
          component: AdminUsersDelete,
          meta: {
            auth: true,
            title: 'Delete Users Account'
          }
        },{
          path: '/admin/users/admin/add',
          component: AdminAddSystemAdmins,
          meta: {
            auth: true,
            title: 'Add System Admins'
          }
        },{
          path: '/admin/users/admin/list',
          component: AdminSystemAdminsList,
          meta: {
            auth: true,
            title: 'System Administrators'
          }
        },{
          path: '/admin/users/admin/list/:id/delete',
          component: AdminSystemAdminsDelete,
          meta: {
            auth: true,
            title: 'Remove System Administrators'
          }
        }]
      },
      {
        path: '/admin/sliders',
        component: AdminSliders,
        meta: {
          auth: true,
          title: 'Sliders'
        }, 
        children: [{
          path: '/admin/sliders/list',
          component: AdminSlidersList,
          meta: {
            auth: true,
            title: 'Sliders List'
          }
        },{
          path: '/admin/sliders/add',
          component: AdminSlidersAdd,
          meta: {
            auth: true,
            title: 'Sliders Add'
          }
        },{
          path: '/admin/sliders/list/edit/:id',
          component: AdminSlidersEdit,
          meta: {
            auth: true,
            title: 'Sliders Edit'
          }
        },{
          path: '/admin/sliders/list/delete/:id',
          component: AdminSlidersDelete,
          meta: {
            auth: true,
            title: 'Sliders Delete'
          }
        }]
      } 
      // {
      //   // UserProfile will be rendered inside User's <router-view>
      //   // when /user/:id/profile is matched
      //   path: '/',
      //   component: AdminAdverts,
      //   meta: {
      //     auth: false,
      //     title: 'AdminAdverts'
      //   }
      // },
      /*{
        // UserProfile will be rendered inside User's <router-view>
        // when /user/:id/profile is matched
        path: '/',
        component: AdminBusiness,
        meta: {
          auth: false,
          title: 'AdminBusiness'
        }
      },
      {
        
        path: '/',
        component: AdminDashboard,
        meta: {
          auth: false,
          title: 'Dashboard'
        }
      },
      {
        // UserProfile will be rendered inside User's <router-view>
        // when /user/:id/profile is matched
        path: '/',
        component: AdminDashboard,
        meta: {
          auth: false,
          title: 'Dashboard'
        }
      },
      */
    ]
  },
  {
    path: '/owner',
    component: Owner,
    children: [
      {
        path: '/owner/dashboard',
        component: OwnerDashboard,
        meta: {
          auth: true,
          title: 'My Dashboard'
        },
        children: [
        ]
      },
      {
        path: '/owner/businesses',
        component: OwnerBusinesses,
        meta: {
          auth: true,
          title: 'My Businesses'
        },
        children: [
          {
            path: '/owner/businesses/register',
            component: OwnerBusinessesRegister,
            meta: {
              auth: true,
              title: 'Register Business'
            }
          },
          {
            path: '/owner/businesses/list',
            component: OwnerBusinessesList,
            meta: {
              auth: true,
              title: 'My Businesses List'
            }
          },
          {
            path: '/owner/businesses/list/view/:id',
            component: OwnerBusinessesView,
            meta: {
              auth: true,
              title: 'My Business Details View'
            }
          },
          {
            path: '/owner/businesses/list/view/:id/products/manage',
            component: OwnerBusinessesManageProducts,
            meta: {
              auth: true,
              title: 'My Business Products Edit'
            }
          },
          {
            path: '/owner/businesses/list/view/:id/services/manage',
            component: OwnerBusinessesManageServices,
            meta: {
              auth: true,
              title: 'My Business Services Edit'
            }
          },
          {
            path: '/owner/businesses/list/view/:id/locations/manage',
            component: OwnerBusinessesManageLocations,
            meta: {
              auth: true,
              title: 'My Business Locations Info Edit'
            }
          },
          {
            path: '/owner/businesses/list/view/:id/delete',
            component: OwnerBusinessesDelete,
            meta: {
              auth: true,
              title: 'My Business Delete'
            }
          },
          {
            path: '/owner/businesses/list/view/:id/schedule/manage',
            component: OwnerBusinessesManageSchedule,
            meta: {
              auth: true,
              title: 'My Business Edit Weekly Schedule Info'
            }
          },
          {
            path: '/owner/businesses/list/view/:id/holidaysschedule/manage',
            component: OwnerBusinessesManageHolidaysSchedule,
            meta: {
              auth: true,
              title: 'My Business Edit Holidays Schedule Info'
            }
          },
          {
            path: '/owner/businesses/list/view/:id/edit_info',
            component: OwnerBusinessesEditInfo,
            meta: {
              auth: true,
              title: 'My Business Edit Basic Info'
            }
          },
          {
            path: '/owner/businesses/list/view/:id/contacts/manage',
            component: OwnerBusinessesManageContacts,
            meta: {
              auth: true,
              title: 'My Business Edit Contacts Info'
            }
          },
          {
            path: '/owner/businesses/list/view/:id/gallery/manage',
            component: OwnerBusinessesManageGallery,
            meta: {
              auth: true,
              title: 'My Business Edit Photoes'
            }
          },
          {
            path: '/owner/businesses/list/view/:id/edit_banner',
            component: OwnerBusinessesEditBanner,
            meta: {
              auth: true,
              title: 'My Business Edit Banner Image'
            }
          },
          {
            path: '/owner/businesses/list/view/:id/verify',
            component: OwnerBusinessesVerify,
            meta: {
              auth: true,
              title: 'My Business Verify'
            }
          },
        ]
      },
      {
        path: '/owner/missing',
        component: OwnerMissing,
        meta: {
          auth: true,
          title: 'Businesses Missing Information Management'
        },
        children: [
          {
            path: '/owner/missing/info',
            component: OwnerMissingInfo,
            meta: {
              auth: true,
              title: 'Businesses Missing Information List'
            }
          },
          {
            path: '/owner/missing/groupby/businesses',
            component: OwnerMissingInfoGroupBusinesses,
            meta: {
              auth: true,
              title: 'Businesses Missing Info Groups'
            }
          },
          {
            path: '/owner/missing/groupby/item',
            component: OwnerMissingInfoGroupItems,
            meta: {
              auth: true,
              title: 'Businesses Missing Info Item Groups'
            }
          },
        ]
      },
      {
        path: '/owner/contact_us_messages',
        component: OwnerContactUsMessages,
        meta: {
          auth: true,
          title: 'Contact Us Messages'
        },
        children: [
          {
            path: '/owner/contact_us_messages/list',
            component: OwnerContactUsMessagesList,
            meta: {
              auth: true,
              title: 'Contact Us Messages List'
            }
          },
          {
            path: '/owner/contact_us_messages/list/view/:id',
            component: OwnerContactUsMessagesView,
            meta: {
              auth: true,
              title: 'View Contact Us Message'
            }
          },
        ]
      },
      {
        path: '/owner/promotions',
        component: OwnerPromotions,
        meta: {
          auth: true,
          title: 'Promotions'
        },
        children: [
          {
            path: '/owner/promotions/list',
            component: OwnerPrommotionsList,
            meta: {
              auth: true,
              title: 'Promotions List'
            }
          },
          {
            path: '/owner/promotions/add',
            component: OwnerPrommotionsAdd,
            meta: {
              auth: true,
              title: 'Promotions Create'
            }
          },
          {
            path: '/owner/promotions/list/view/:id',
            component: OwnerPromtionsView,
            meta: {
              auth: true,
              title: 'View Promotion Details'
            }
          },
          {
            path: '/owner/promotions/list/view/:id/end',
            component: OwnerPromtionsEnd,
            meta: {
              auth: true,
              title: 'End Promotion'
            }
          },
          {
            path: '/owner/promotions/list/view/:id/delete',
            component: OwnerPromtionsDelete,
            meta: {
              auth: true,
              title: 'Delete Promotion'
            }
          },
          {
            path: '/owner/promotions/list/view/:id/edit',
            component: OwnerPromotionsEdit,
            meta: {
              auth: true,
              title: 'Edit Promotion'
            }
          },
        ]
      },
      {
        path: '/owner/notifications',
        component: OwnerNotifications,
        meta: {
          auth: true,
          title: 'Notification'
        },
        children: [
          {
            path: '/owner/notifications/list',
            component: OwnerNotificationsList,
            meta: {
              auth: true,
              title: 'Notifications List'
            }
          },
        ]
      },
      {
        path: '/owner/reports',
        component: OwnerReports,
        meta: {
          auth: true,
          title: 'My Reports'
        },
        children: [{
          path: '/owner/reports/promotions',
          component: OwnerReportsPromotions,
          meta: {
            auth: true,
            title: 'Promotions Report'
          }
        }, {
          path: '/owner/reports/overdue',
          component: OwnerReportsOverdue,
          meta: {
            auth: true,
            title: 'Overdue Promotions Report'
          }
        }, {
          path: '/owner/reports/views',
          component: OwnerReportsBusinessViews,
          meta: {
            auth: true,
            title: 'My Businesses View Report'
          }
        }, {
          path: '/owner/reports/searches',
          component: OwnerReportsBusinessSearches,
          meta: {
            auth: true,
            title: 'My Businesses Searched Report'
          }
        }, {
          path: '/owner/reports/reviews',
          component: OwnerReportsBusinessReviews,
          meta: {
            auth: true,
            title: 'My Businesses Reviews Report'
          }
        }, {
          path: '/owner/reports/ratings',
          component: OwnerReportsBusinessRatings,
          meta: {
            auth: true,
            title: 'My Businesses Ratings Report'
          }
        }]
      },
      {
        path: '/owner/security',
        component: OwnerSecurity,
        meta: {
          auth: true,
          title: 'Security'
        },
        children: [{
          path: '/owner/security/password/update',
          component: OwnerSecurityPassword,
          meta: {
            auth: true,
            title: 'Update Password'
          }
        }, {
          path: '/owner/security/username/update',
          component: OwnerSecurityUsername,
          meta: {
            auth: true,
            title: 'Update User Name'
          }
        }, {
          path: '/owner/security/details/update',
          component: OwnerSecurityDetails,
          meta: {
            auth: true,
            title: 'Update User Details'
          }
        }]
      }
    ]
  },
  {
    path: '/promotions',
    component: Promotions,
    meta: {
      auth: false,
      title: 'Promotions'
    }
  },
  {
    path: '/promotions/group/:group_name',
    component: PromotionsGroup,
    meta: {
      auth: false,
      title: 'Featured Promotions'
    }
  },
  {
    path: '/promotions/:id',
    component: Promotion,
    meta: {
      auth: false,
      title: 'Promotion Details'
    }
  },
  {
    path: '/categories',
    component: Categories,
    meta: {
      auth: false,
      title: 'Categories'
    }
  },
  {
    path: '/categories/:id',
    component: Category,
    meta: {
      auth: false,
      title: 'Category Details'
    }
  },
  {
    path: '/categories/:cat_id/sub/:id',
    component: SubCategory,
    meta: {
      auth: false,
      title: 'Sub Category Details'
    }
  },
  {
    path: '/directory',
    component: Directory,
    meta: {
      auth: false,
      title: 'Directory Details'
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
